import React from 'react';
import PropTypes from 'prop-types';

const OrganicShapeB = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 642 1019">
      <polygon
        fill={props.color}
        points="172.043 0 642 272.952 642 1019 0 761.977 84.398 476.804 261.852 419.038 152.566 357.722 101.711 227.838 199.094 101.936 156.895 69.579"
      />
    </svg>
  );
};

OrganicShapeB.defaultProps = {
  color: '#000000',
};

OrganicShapeB.propTypes = {
  color: PropTypes.string,
};

export default OrganicShapeB;
